<!--
# Module: 超计划管理
-->
<template>
  <div class="manage-page">
    <div class="page-view">
      <div class="item-row" v-for="w in navMenu" :key="w.id" @click="opendialog(w.id)">
        <div class="name">
          <span>{{w.title}}</span>
        </div>
        <p class="tips">{{w.dec}}</p>
      </div>
    </div>
    <common-dialog
      append-to-body
      v-if="dialogVisible"
      :title="dialogOptions.title"
      :width="dialogOptions.width"
      :height="dialogOptions.height"
      :visible.sync="dialogVisible"
      cover
    >
      <bill-list @cancel="dialogVisible=false"></bill-list>
    </common-dialog>
  </div>
</template>

<script>
import billList from '@/components/recordListTable/billList.vue'
export default {
  name: "overPlanManage",
  components: {
    billList
  },
  data () {
    return {
      dialogOptions: {
        title: '',
        width: '600px',
        height: ''
      },
      dialogVisible: false // 是否显示弹框
    }
  },
  computed: {
    // 选项卡：菜单导航
    navMenu () {
      return [
        { id: 'overPlanManage', title: '处理待缴费记录', dec: '处理代缴费的记录' }
      ]
    }
  },
  methods: {
    // 功能：打开弹框,赋值
    opendialog (e) {
      switch (e) {
        case 'overPlanManage':
          this.dialogOptions.width = '1000px'
          this.dialogOptions.title = "待缴费记录列表"
          break
      }
      this.dialogVisible = true
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-marleft {
  margin-left: 20px;
}
</style>